import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Translator } from './translator';
import logo from '../images/Footer/LOGHI_TECHE.png';

export default function Footer() {
  const { translateText, lang } = Translator();

  const baseTextByLang = {
    it: {
      text1: "Assistenza",
      text2: "Il mio Profilo",
      text3: "Informazioni legali",
      text4: "Informativa sulla privacy",
      text5: "Cookies di marketing",
      text6: "Termini e condizioni generali",
      text7: "Informazioni ai sensi della legge sui servizi digitali",
      //text8: "Termini e condizioni NFT",
      text9_1: "Home",
      text9: "Chi siamo",
      text10: "Tour Digitali",
      text11: "FuoriRotta",
      text12: "Community",
      text13: "Messaggi",
      text13_1: "Amici",
      //text14: "Collabora con noi",
      //text15: "Diventa Partner",
      //text16: "NFT",
      text17: "Metodi di Pagamento",
      text18: "Scarica la nostra app",
      text19:
        "– RIPRODUZIONE VIETATA. TUTTI I CONTENUTI (FOTO, TESTI, VIDEO, AUDIO, ECC.) SONO ORIGINALI DI EMOZIONARTI S.R.L. E PERTANTO PROTETTI DA COPYRIGHT. LA COPIA E LA RIPRODUZIONE, ANCHE PARZIALE, SONO VIETATE.",
    },

    en: {
      text1: "Support",
      text2: "My Profile",
      text3: "Legal information",
      text4: "Privacy policy",
      text5: "Marketing cookies",
      text6: "Terms and conditions",
      text7: "Digital Services Act information",
      //text8: "NFT terms and conditions",
      text9_1: "Home",
      text9: "About us",
      text10: "Digital Tours",
      text11: "FuoriRotta",
      text12: "Community",
      text13: "Messages",
      text13_1: "Friends",
      //text14: "Work with us",
      //text15: "Become Partner",
      //text16: "NFT",
      text17: "Payment Methods",
      text18: "Download our app",
      text19:
        "– REPRODUCTION PROHIBITED. ALL CONTENT (PHOTOS, TEXTS, VIDEOS, AUDIO, ETC.) IS ORIGINAL AND PROTECTED BY COPYRIGHT. COPYING OR REPRODUCTION, EVEN PARTIAL, IS PROHIBITED.",
    },

    fr: {
      text1: "Assistance",
      text2: "Mon Profil",
      text3: "Informations légales",
      text4: "Politique de confidentialité",
      text5: "Cookies marketing",
      text6: "Termes et conditions",
      text7: "Informations selon la loi sur les services numériques",
      //text8: "Termes et conditions NFT",
      text9_1: "Accueil",
      text9: "À propos",
      text10: "Tours Digitaux",
      text11: "FuoriRotta",
      text12: "Community",
      text13: "Messages",
      text13_1: "Amis",
      //text14: "Collaborez avec nous",
      //text15: "Devenir Partenaire",
      //text16: "NFT",
      text17: "Méthodes de paiement",
      text18: "Téléchargez notre app",
      text19:
        "– REPRODUCTION INTERDITE. TOUS LES CONTENUS (PHOTOS, TEXTES, VIDÉOS, AUDIO, ETC.) SONT ORIGINAUX ET PROTÉGÉS PAR DROIT D’AUTEUR. LA COPIE ET LA REPRODUCTION, MÊME PARTIELLE, SONT INTERDITES.",
    },
  };

  // Fallback base = Italian
  const fallbackBase = baseTextByLang.it;

  const [translatedText, setTranslatedText] = useState(
    baseTextByLang[lang] || fallbackBase
  );

  // AUTO UPDATE WHEN LANGUAGE CHANGES
  useEffect(() => {
    // If language is directly supported → no translation API call
    if (lang === "it" || lang === "en" || lang === "fr") {
      setTranslatedText(baseTextByLang[lang]);
      return;
    }

    // Otherwise → translate Italian source dynamically
    let cancelled = false;

    async function translateAll() {
      const entries = Object.entries(fallbackBase);

      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => {
          const out = await translateText(value);
          return [key, out || value];
        })
      );

      if (!cancelled) {
        setTranslatedText(Object.fromEntries(translatedEntries));
      }
    }

    translateAll();

    return () => {
      cancelled = true;
    };
  }, [lang, translateText]);


return (
  <footer className="bg-white border-t w-full overflow-x-hidden">

    <div className="mx-auto max-w-[1440px] px-4 sm:px-8 py-10 sm:py-12">
      {/* 12-col grid to avoid leftover gaps */}
      <div className="grid grid-cols-12 gap-x-6 sm:gap-x-10 gap-y-10 items-start">
        {/* LOGO — wide on desktop, full width on mobile */}
        <div className="col-span-12 lg:col-span-6 min-w-0">
<div className="mb-6">
  <p className="text-center sm:text-left text-lg font-semibold mb-3">
    {translatedText.text18}
  </p>

  {/* Equal heights across breakpoints = equal visual size */}
  <div className="flex flex-col sm:flex-row items-center sm:items-start justify-center sm:justify-start gap-4">
    <a
      href="https://apps.apple.com/it/app/techetour/id6747498516"
      target="_blank"
      rel="noopener noreferrer"
      className="shrink-0 h-16 sm:h-20 md:h-24 lg:h-24 max-h-[18vh]"
    >
      <img src="../images/Footer/IOS.jpeg" alt="App Store" className="block h-full w-auto max-w-full" />
    </a>

    <a
      href="https://play.google.com/store/apps/details?id=com.techetour"
      target="_blank"
      rel="noopener noreferrer"
      className="shrink-0 h-16 sm:h-20 md:h-24 lg:h-24 max-h-[18vh]"
    >
      <img src="../images/Footer/Google.png" alt="Google Play" className="block h-full w-auto max-w-full" />
    </a>
  </div>
</div>

          <img
            src={logo}
            alt="Te.C.H-e"
            className="w-full h-auto max-w-full object-contain"
          />
        </div>

        {/* SITEMAP */}
        <div className="col-span-6 sm:col-span-4 lg:col-span-2 text-left min-w-0">
          <ul className="space-y-2 text-sm md:text-base">
            <li><Link to="/"        className="text-black no-underline hover:no-underline">{translatedText.text9_1}</Link></li>
            <li><Link to="/blog"    className="text-black no-underline hover:no-underline">{translatedText.text2}</Link></li>
            <li><Link to="/About"   className="text-black no-underline hover:no-underline">{translatedText.text9}</Link></li>
            <li><Link to="/choose"  className="text-black no-underline hover:no-underline">{translatedText.text10}</Link></li>
            <li><Link to="/FuoriPreview/127981" className="text-black no-underline hover:no-underline">{translatedText.text11}</Link></li>
            <li><Link to="/community"  className="text-black no-underline hover:no-underline">{translatedText.text12}</Link></li>
            <li><Link to="/messages"     className="text-black no-underline hover:no-underline">{translatedText.text13}</Link></li>
            <li><Link to="/friends" className="text-black no-underline hover:no-underline">{translatedText.text13_1}</Link></li>
          </ul>
        </div>

        {/* ASSISTENZA / LEGAL */}
        <div className="col-span-6 sm:col-span-4 lg:col-span-2 text-left min-w-0">
          <ul className="space-y-2 text-sm md:text-base">
            <li><Link to="/support"      className="text-black no-underline hover:no-underline">{translatedText.text1}</Link></li>
            <li><Link to="/legal"        className="text-black no-underline hover:no-underline">{translatedText.text3}</Link></li>
            <li><Link to="/privacy"      className="text-black no-underline hover:no-underline">{translatedText.text4}</Link></li>
            <li><Link to="/cookies"      className="text-black no-underline hover:no-underline">{translatedText.text5}</Link></li>
            <li><Link to="/conditions"   className="text-black no-underline hover:no-underline">{translatedText.text6}</Link></li>
            <li><Link to="/infolegge"    className="text-black no-underline hover:no-underline">{translatedText.text7}</Link></li>
            {/*<li><Link to="/NFTConditions" className="text-black no-underline hover:no-underline">{translatedText.text8}</Link></li>*/}
          </ul>
        </div>

        {/* PAYMENT + APPS — sits flush right on wide screens */}
        <div className="col-span-12 lg:col-span-2 xl:col-span-2 2xl:col-span-2 lg:justify-self-end w-full text-left flex flex-col gap-5 min-w-0">
          <div className="w-full overflow-hidden">
            <p className="font-semibold mb-2">{translatedText.text17}</p>
            <img
              src="https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/payment_methods.jpg"
              alt="Metodi di pagamento"
              className="w-full max-w-[560px] h-auto object-contain"
            />
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-8 border-t pt-4 text-center text-xs text-black">
        © {new Date().getFullYear()} Te.C.H-e {translatedText.text19}
      </div>
    </div>
  </footer>
);
}
